"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderFillDelay = exports.parseOrderStatus = exports.buildOrder = exports.getOrderLimitPriceRate = exports.getOrderExcecutionRate = exports.Orders = void 0;
var types_1 = require("./types");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var utils_1 = require("./utils");
var lib_1 = require("./lib");
var consts_1 = require("./consts");
function groupFillsByTWAP(fills) {
    var groupedMap = new Map();
    for (var _i = 0, fills_1 = fills; _i < fills_1.length; _i++) {
        var fill = fills_1[_i];
        var id = fill.TWAP_id;
        if (!groupedMap.has(id)) {
            groupedMap.set(id, []);
        }
        groupedMap.get(id).push(fill);
    }
    return Array.from(groupedMap.entries()).map(function (_a) {
        var id = _a[0], fills = _a[1];
        return ({
            id: id,
            fills: fills,
            twapAddress: fills[0].twapAddress,
            exchange: fills[0].exchange,
        });
    });
}
var parseFills = function (fills) {
    var initial = {
        dstAmountOut: (0, bignumber_js_1.default)(0),
        srcAmountIn: (0, bignumber_js_1.default)(0),
        dollarValueIn: (0, bignumber_js_1.default)(0),
        dollarValueOut: (0, bignumber_js_1.default)(0),
        dexFee: (0, bignumber_js_1.default)(0),
    };
    var result = fills.reduce(function (acc, it) { return ({
        dstAmountOut: acc.dstAmountOut.plus((0, bignumber_js_1.default)(it.dstAmountOut || 0)),
        srcAmountIn: acc.srcAmountIn.plus((0, bignumber_js_1.default)(it.srcAmountIn || 0)),
        dollarValueIn: acc.dollarValueIn.plus((0, bignumber_js_1.default)(it.dollarValueIn || 0)),
        dollarValueOut: acc.dollarValueOut.plus((0, bignumber_js_1.default)(it.dollarValueOut || 0)),
        dexFee: acc.dexFee.plus((0, bignumber_js_1.default)(it.dstFee || 0)),
    }); }, initial);
    return {
        filledDstAmount: result.dstAmountOut.toString(),
        filledSrcAmount: result.srcAmountIn.toString(),
        filledDollarValueIn: result.dollarValueIn.toString(),
        filledDollarValueOut: result.dollarValueOut.toString(),
        dexFee: result.dexFee.toString(),
    };
};
var Orders = /** @class */ (function () {
    function Orders(config) {
        this.config = config;
        this.exchanges = __spreadArray([this.config.exchangeAddress], (consts_1.LEGACY_EXCHANGES_MAP[this.config.name] || []), true).map(function (a) { return "\"".concat(a.toLowerCase(), "\""); }).join(", ");
        this.endpoint = (0, utils_1.getTheGraphUrl)(this.config.chainId);
    }
    Orders.prototype.getCreatedOrders = function (account, signal) {
        return __awaiter(this, void 0, void 0, function () {
            var limit, exchange, maker, where, orders, page, query, payload, response, orderCreateds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        limit = 1000;
                        exchange = "exchange_in: [".concat(this.exchanges, "]");
                        maker = "maker: \"".concat(account, "\"");
                        where = "where:{".concat(exchange, ", ").concat(maker, "}");
                        orders = [];
                        page = 0;
                        _a.label = 1;
                    case 1:
                        if (!true) return [3 /*break*/, 4];
                        query = "\n        {\n          orderCreateds(\n            first: ".concat(limit, ",\n            orderBy: timestamp,\n            orderDirection: desc,\n            skip: ").concat(page * limit, ",\n            ").concat(where, "\n          ) {\n            id\n            twapAddress\n            Contract_id\n            ask_bidDelay\n            ask_data\n            ask_deadline\n            ask_dstMinAmount\n            ask_dstToken\n            ask_fillDelay\n            ask_exchange\n            ask_srcToken\n            ask_srcBidAmount\n            ask_srcAmount\n            blockNumber\n            blockTimestamp\n            dex\n            dollarValueIn\n            dstTokenSymbol\n            exchange\n            maker\n            srcTokenSymbol\n            timestamp\n            transactionHash\n          }\n        }\n      ");
                        return [4 /*yield*/, fetch(this.endpoint, {
                                method: "POST",
                                body: JSON.stringify({ query: query }),
                                signal: signal,
                            })];
                    case 2:
                        payload = _a.sent();
                        return [4 /*yield*/, payload.json()];
                    case 3:
                        response = _a.sent();
                        orderCreateds = response.data.orderCreateds;
                        orders.push.apply(orders, orderCreateds);
                        if (orderCreateds.length < limit) {
                            return [3 /*break*/, 4]; // No more orders to fetch
                        }
                        page++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, orders];
                }
            });
        });
    };
    Orders.prototype.getFills = function (ids, signal) {
        return __awaiter(this, void 0, void 0, function () {
            var LIMIT, page, where, fills, dexFee, query, payload, response, groupedFills;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        LIMIT = 1000;
                        page = 0;
                        where = "where: { TWAP_id_in: [".concat(ids.join(", "), "], exchange_in: [").concat(this.exchanges, "] }");
                        fills = [];
                        dexFee = this.config.chainId === 56 ? "dexFee" : "";
                        _a.label = 1;
                    case 1:
                        if (!true) return [3 /*break*/, 4];
                        query = "\n      {\n        orderFilleds(first: ".concat(LIMIT, ", orderBy: timestamp, skip: ").concat(page * LIMIT, ", ").concat(where, ") {\n          id\n          dstAmountOut\n          dstFee\n          srcFilledAmount\n          twapAddress\n          exchange\n          TWAP_id\n          srcAmountIn\n          timestamp\n          dollarValueIn\n          dollarValueOut,\n          ").concat(dexFee, "\n        }\n      }\n    ");
                        return [4 /*yield*/, fetch(this.endpoint, {
                                method: "POST",
                                body: JSON.stringify({ query: query }),
                                signal: signal,
                            })];
                    case 2:
                        payload = _a.sent();
                        return [4 /*yield*/, payload.json()];
                    case 3:
                        response = _a.sent();
                        groupedFills = groupFillsByTWAP(response.data.orderFilleds);
                        fills.push.apply(fills, groupedFills);
                        if (groupedFills.length < LIMIT)
                            return [3 /*break*/, 4];
                        page++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, fills];
                }
            });
        });
    };
    Orders.prototype.getOrders = function (account, signal) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, createdOrders, ids, allFills, parsedOrders;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = (0, utils_1.getTheGraphUrl)(this.config.chainId);
                        if (!endpoint) {
                            throw new Error("no endpoint found");
                        }
                        return [4 /*yield*/, this.getCreatedOrders(account.toLowerCase(), signal)];
                    case 1:
                        createdOrders = _a.sent();
                        ids = createdOrders.map(function (rawOrder) { return rawOrder.Contract_id.toString(); });
                        return [4 /*yield*/, this.getFills(ids, signal)];
                    case 2:
                        allFills = _a.sent();
                        parsedOrders = createdOrders.map(function (o) {
                            var fills = allFills === null || allFills === void 0 ? void 0 : allFills.find(function (it) { return it.id === Number(o.Contract_id) && it.exchange === o.exchange && it.twapAddress === o.twapAddress; });
                            return (0, exports.buildOrder)({
                                fills: fills === null || fills === void 0 ? void 0 : fills.fills,
                                srcAmount: o.ask_srcAmount,
                                srcTokenAddress: o.ask_srcToken,
                                dstTokenAddress: o.ask_dstToken,
                                srcAmountPerChunk: o.ask_srcBidAmount,
                                deadline: o.ask_deadline * 1000,
                                dstMinAmountPerChunk: o.ask_dstMinAmount,
                                tradeDollarValueIn: o.dollarValueIn,
                                blockNumber: o.blockNumber,
                                id: Number(o.Contract_id),
                                fillDelay: o.ask_fillDelay,
                                createdAt: new Date(o.timestamp).getTime(),
                                txHash: o.transactionHash,
                                maker: o.maker,
                                exchange: o.exchange,
                                twapAddress: o.twapAddress,
                            });
                        });
                        return [2 /*return*/, parsedOrders];
                }
            });
        });
    };
    return Orders;
}());
exports.Orders = Orders;
var getOrderType = function (dstMinAmount, chunks) {
    var isLimit = (0, bignumber_js_1.default)(dstMinAmount || 0).gt(1);
    var isTwap = chunks > 1;
    if (isTwap && chunks === 1) {
        return types_1.OrderType.TWAP_MARKET;
    }
    if (isTwap && isLimit) {
        return types_1.OrderType.TWAP_LIMIT;
    }
    if (isLimit) {
        return types_1.OrderType.LIMIT;
    }
    return types_1.OrderType.TWAP_MARKET;
};
var getOrderExcecutionRate = function (order, srcTokenDecimals, dstTokenDecimals) {
    if (!(0, bignumber_js_1.default)(order.filledSrcAmount || 0).gt(0) || !(0, bignumber_js_1.default)(order.filledDstAmount || 0).gt(0))
        return "";
    var srcFilledAmountUi = (0, utils_1.amountUi)(srcTokenDecimals, order.filledSrcAmount);
    var dstFilledAmountUi = (0, utils_1.amountUi)(dstTokenDecimals, order.filledDstAmount);
    return (0, bignumber_js_1.default)(dstFilledAmountUi).div(srcFilledAmountUi).toFixed();
};
exports.getOrderExcecutionRate = getOrderExcecutionRate;
var getOrderLimitPriceRate = function (order, srcTokenDecimals, dstTokenDecimals) {
    if (order.type === types_1.OrderType.TWAP_MARKET) {
        return (0, exports.getOrderExcecutionRate)(order, srcTokenDecimals, dstTokenDecimals);
    }
    var srcBidAmountUi = (0, utils_1.amountUi)(srcTokenDecimals, order.srcAmountPerChunk);
    var dstMinAmountUi = (0, utils_1.amountUi)(dstTokenDecimals, order.dstMinAmountPerChunk);
    return (0, bignumber_js_1.default)(dstMinAmountUi).div(srcBidAmountUi).toFixed();
};
exports.getOrderLimitPriceRate = getOrderLimitPriceRate;
var buildOrder = function (_a) {
    var fills = _a.fills, srcAmount = _a.srcAmount, srcTokenAddress = _a.srcTokenAddress, dstTokenAddress = _a.dstTokenAddress, _b = _a.srcAmountPerChunk, srcAmountPerChunk = _b === void 0 ? "1" : _b, deadline = _a.deadline, dstMinAmountPerChunk = _a.dstMinAmountPerChunk, tradeDollarValueIn = _a.tradeDollarValueIn, blockNumber = _a.blockNumber, id = _a.id, fillDelay = _a.fillDelay, createdAt = _a.createdAt, txHash = _a.txHash, maker = _a.maker, exchange = _a.exchange, twapAddress = _a.twapAddress;
    var _c = parseFills(fills || []), filledDstAmount = _c.filledDstAmount, filledSrcAmount = _c.filledSrcAmount, filledDollarValueIn = _c.filledDollarValueIn, filledDollarValueOut = _c.filledDollarValueOut, dexFee = _c.dexFee;
    var chunks = new bignumber_js_1.default(srcAmount || 0)
        .div(srcAmountPerChunk) // Avoid division by zero
        .integerValue(bignumber_js_1.default.ROUND_FLOOR)
        .toNumber();
    var type = getOrderType(dstMinAmountPerChunk, chunks);
    return {
        id: id,
        type: type,
        exchange: exchange,
        twapAddress: twapAddress,
        maker: maker,
        progress: getOrderProgress(srcAmount, filledSrcAmount),
        filledDstAmount: filledDstAmount,
        filledSrcAmount: filledSrcAmount,
        filledDollarValueIn: filledDollarValueIn,
        filledDollarValueOut: filledDollarValueOut,
        filledFee: dexFee,
        fills: fills,
        srcTokenAddress: srcTokenAddress,
        dstTokenAddress: dstTokenAddress,
        tradeDollarValueIn: tradeDollarValueIn,
        blockNumber: blockNumber,
        fillDelay: fillDelay,
        deadline: deadline,
        createdAt: createdAt,
        srcAmount: srcAmount,
        dstMinAmountPerChunk: Number(dstMinAmountPerChunk) === 1 ? "0" : dstMinAmountPerChunk,
        srcAmountPerChunk: srcAmountPerChunk,
        txHash: txHash,
        chunks: chunks,
        dstMinAmount: Number(dstMinAmountPerChunk) === 1 ? "0" : new bignumber_js_1.default(dstMinAmountPerChunk).times(chunks).toString(),
        isMarketOrder: type === types_1.OrderType.TWAP_MARKET,
    };
};
exports.buildOrder = buildOrder;
var getOrderProgress = function (srcAmount, filledSrcAmount) {
    if (!filledSrcAmount || !srcAmount)
        return 0;
    var progress = (0, bignumber_js_1.default)(filledSrcAmount).dividedBy(srcAmount).toNumber();
    if (progress >= 0.99)
        return 100;
    if (progress <= 0)
        return 0;
    return progress * 100;
};
var parseOrderStatus = function (progress, status) {
    if (progress === 100)
        return types_1.OrderStatus.Completed;
    if (status && status > Date.now() / 1000)
        return types_1.OrderStatus.Open;
    switch (status) {
        case 1:
            return types_1.OrderStatus.Canceled;
        case 2:
            return types_1.OrderStatus.Completed;
        default:
            return types_1.OrderStatus.Expired;
    }
};
exports.parseOrderStatus = parseOrderStatus;
var getOrderFillDelay = function (fillDelay, config) {
    return (fillDelay || 0) * 1000 + (0, lib_1.getEstimatedDelayBetweenChunksMillis)(config);
};
exports.getOrderFillDelay = getOrderFillDelay;
